<template>
  <div>
    <div class="myClass">
      <!-- <ul class="tabs">
        <li @click="changeCourseType(1)" :class="courseType == 1 ? 'classic active' : ''">公开课</li>
        <li @click="changeCourseType(2)" :class="courseType == 2 ? 'classic active' : ''">专业课</li>
      </ul> -->
      <div class="current-tabs">
        <div class="left-tabs">
          <div :class="['item',type == 0?'active':'']" @click="changeType(0)">我的全部课程</div>
          <div :class="['item',type == 1?'active':'']" @click="changeType(1)">已学习的课程</div>
        </div>
        <div class="input-box">
          <input type="text" v-model="courseName" placeholder="请输入课程名称">
          <div class="search-btn" @click="lodData()"></div>
        </div>
      </div>
      <ul class="classContents">
        <!-- 学习中心 已下架class-list-grey 已完成iconwancheng  去掉待学习、 -->
        <li v-for="(item, i) in this.data" :key="i" :class="item.status == 3 || item.remaining_day == 0 ? 'disabled' : ''">
          <div class="classImages" @click="goClassDetails(item)">
            <!-- <span class="iconfont iconsuo" v-if="item.status == 1">{{item.status_name}}</span> -->
            <span class="iconfont class-list-grey" v-if="item.remaining_day == 0">已过期</span>
            <template v-else>
              <span class="iconfont iconwancheng" v-if="item.status == 2">{{item.status_name}}</span>
              <span class="iconfont class-list-grey" v-else-if="item.status == 3">{{item.status_name}}</span>
            </template>
            <img :src="item.photo" alt />
          </div>
          <div class="classInfo">
            <div class="info">
              <h3 @click="goClassDetails(item)">{{item.name}}</h3>
              <p>
                <span v-if="item.category_name" class="className">{{item.category_name}}</span>
                <span class="className">课程总时长：{{item.total_time}}</span>
                <span>课程讲师：{{item.teacher}}</span>
              </p>
              <p class="con">{{item.abstract}}</p>
              <div class="btm">
                <p class="residue" v-if="item.type != 1 && item.remaining_day != 0">
                  学习有效期剩余：
                  <span>{{item.remaining_day}}天</span>
                </p>
                <p class="residue residue-daoqi" v-if="item.type != 1 && item.remaining_day == 0">
                  <span>{{item.end_date}}已到期</span>
                </p>
                <p class="pre">
                  <span class="pre-label">学习进度：</span>
                  <a-progress :percent="item.learn_percent" />
                </p>
              </div>
            </div>
            <div class="rightButtom">
              <a-button v-if="item.remaining_day != 0 && item.status != 3" type="primary" shape="round" @click="classToDetail(item)">立即学习</a-button>
            </div>
          </div>
        </li>
      </ul>
      <div class="pages" v-if="this.data.length > 0">
        <a-pagination :defaultPageSize="10" @change="onChange" :locale="zhCN" :default-current="1" :total="this.num" :current="currentPage" />
      </div>
      <div v-else class="noData-box">
        <img src="@/assets/empty.png" alt="">
        <div class="text">暂无相关内容</div>
      </div>
    </div>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/es/locale-provider/zh_CN";
import { Button, Progress, Pagination } from "ant-design-vue";
import services from "../../../config/services";
import utils from "../../../config/utils";
import { mapState } from "vuex";
export default {
  name: "MyClass",
  components: {
    AButton: Button,
    AProgress: Progress,
    APagination: Pagination,
  },
  data () {
    return {
      data: [],
      num: 0,
      zhCN,
      services: services,
      courseType: 1,
      currentPage: 1,
      type: "0",// 默认查询已学课程 1已学 0全部
      courseName: "" // 课程名称
    };
  },
  computed: {
    ...mapState({
      userAllInfo: state => state.appsLogin.appsUserInfo,
    }),
  },
  methods: {
    onChange (pageNumber) {
      this.lodData({
        page: pageNumber
      });
      this.currentPage = pageNumber;
    },
    classToDetail (item) {
      if (item.status != 3 && item.remaining_day != 0) {
        utils.redirect(this, `/${this.userAllInfo.school_code}/video/${item.id}/0?from=${this.$route.path}`, true);
      }
    },
    goClassDetails (item) {
      if (item.status != 3 && item.remaining_day != 0) {
        utils.redirect(this, `/${this.userAllInfo.school_code}/class/${item.id}`, true);
      }
    },
    lodData (params) {
      services.getUserCourseList({
        page: 1,
        size: 10,
        q: this.courseName,
        is_learn: this.type,
        // type: this.courseType,
        ...params,
      })
        .then((res) => {
          if (res.code === "0000") {
            this.data = res.data.items;
            this.num = res.data.total;
          }
          // this.imgCode = window.URL.createObjectURL(res);
        });
    },
    changeCourseType (type) {
      if (type != this.courseType) {
        this.courseType = type;
        this.currentPage = 1;
        this.lodData({ page: 1 });
      }
    },
    changeType (type) {
      if (type != this.type) {
        this.type = type
        // this.courseName = ""
        this.currentPage = 1
        this.lodData({ page: 1 })
      }
    }
  },

  mounted () {
    this.$store.commit("setNavTitle", {
      navTitle: "学习中心",
    });
    this.lodData({ page: 1 });
  },
};
</script>
<style lang="less" scoped>
.major-box {
  width: 100%;
  .major-items {
    width: 60px;
    height: 28px;
    background: inherit;
    background-color: rgba(36, 98, 245, 1);
    border-radius: 6px;
    color: #ffffff;
  }
}
.noData-box {
  width: 100%;
  text-align: center;
  height: 770px;
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 150px;
  img {
    width: 240px;
    height: auto;
    margin: 0 auto 30px;
  }
  .text {
    color: #76797e;
    font-size: 14px;
  }
}
.myClass {
  .current-tabs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 26px;
    border-bottom: 1px solid #eceff1;
    .left-tabs {
      display: flex;
      .item {
        cursor: pointer;
        padding-bottom: 18px;
        font-size: 16px;
        color: #545c63;
        &:not(:last-child) {
          margin-right: 45px;
        }
        &.active {
          color: #125cfd;
          border-bottom: 2px solid #125cfd;
        }
      }
    }
    .input-box {
      position: relative;
      top: -5px;
      &::before {
        content: '';
        display: inline-block;
        position: absolute;
        width: 1px;
        height: 18px;
        background: #e1e4e8;
        top: 50%;
        transform: translateY(-50%);
        right: 38px;
      }
      .search-btn {
        display: inline-block;
        position: absolute;
        background-image: url('../../../assets/search.png');
        width: 17px;
        height: 17px;
        background-size: cover;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        cursor: pointer;
      }
      input {
        width: 257px;
        height: 33px;
        background: #f6f7fb;
        border: 1px solid #f6f7fb;
        padding: 0 16px;
        color: #545c63;
        font-size: 14px;
        &::placeholder {
          color: #b0b0b0;
        }
      }
    }
  }
}
</style>